import { fetcher_default } from "./chunk-GONJSORR.mjs";
import { __export } from "./chunk-QK4PKNB3.mjs"; // src/services/measurement.ts

var measurement_exports = {};

__export(measurement_exports, {
  createMeasurement: function createMeasurement() {
    return _createMeasurement;
  },
  createMeasurementDrafts: function createMeasurementDrafts() {
    return _createMeasurementDrafts;
  },
  getMeasurementDrafts: function getMeasurementDrafts() {
    return _getMeasurementDrafts;
  },
  getMeasurementList: function getMeasurementList() {
    return _getMeasurementList;
  },
  getSOAP: function getSOAP() {
    return _getSOAP;
  },
  updateMeasurementDrafts: function updateMeasurementDrafts() {
    return _updateMeasurementDrafts;
  }
});

var _getMeasurementList = function _getMeasurementList(_ref) {
  var provider = _ref.provider;
  return fetcher_default.get("/v4/measurements", {
    provider: provider
  });
};

var _getSOAP = function _getSOAP() {
  return fetcher_default.get("/v4/clinic_soaps", {});
};

var _createMeasurementDrafts = function _createMeasurementDrafts(payload) {
  return fetcher_default.post("/v4/measurement_drafts", payload);
};

var _updateMeasurementDrafts = function _updateMeasurementDrafts(payload) {
  var id = payload.id,
      data = payload.data;
  return fetcher_default.put("/v4/measurement_drafts/".concat(id), {
    data: {
      measurement_attributes: data
    }
  });
};

var _getMeasurementDrafts = function _getMeasurementDrafts(id) {
  return fetcher_default.get("/v4/measurement_drafts/".concat(id));
};

var _createMeasurement = function _createMeasurement(id) {
  return fetcher_default.post("/v4/measurement_drafts/".concat(id, "/save_as_measurement"));
};

export { _getMeasurementList as getMeasurementList, _getSOAP as getSOAP, _createMeasurementDrafts as createMeasurementDrafts, _updateMeasurementDrafts as updateMeasurementDrafts, _getMeasurementDrafts as getMeasurementDrafts, _createMeasurement as createMeasurement, measurement_exports };